// extracted by mini-css-extract-plugin
export default {"Card":"VerticalCard_Card__DbDNR","Image":"VerticalCard_Image__-WHrW","Title":"VerticalCard_Title__Aaswq"};